import { CONCAT_TEXT_LIMIT, HEADER_TAB_SETUP } from "../../functions/funtion";
import { PT_PROFILE } from "../../routes/stack/paths/pt-profile";
import { dto_common } from "../../classes/dto-common";
import React from "react";

export default class PRIVACYPOLICY extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: "",
    };
  }

  async componentDidMount() {
    let CSP = dto_common.CSP;
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Privacy policy",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_PROFILE);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => { },
    });

    if (CSP === "AV") {
      this.setState({
        url: "https://privacy-policy.daitonn.com?AVAS-FOOD",
      });
    } else if (CSP === "MK") {
      this.setState({
        url: "https://privacy-policy.daitonn.com?MKB",
      });
    } else if (CSP === "DT") {
      this.setState({
        url: "https://privacy-policy.daitonn.com?DAITONN-ONLINE",
      });
    } 
  }

  render() {
    return (
      <div style={{ marginTop: 80, width: "93%", padding: 10, height: 600 }}>
        <iframe
          title={this.state.url}
          src={this.state.url}
          width={"100%"}
          allowFullScreen
          height={"100%"}
        ></iframe>
      </div>
    );
  }
}
